import { Outlet } from 'react-router-dom';

import { useOrderAutosave } from '../api/useAutosave';
import styles from '../ResellerLayout.module.css';

export const ResellerOrder = () => {
  useOrderAutosave();

  return (
    <div className={styles.orderLayout}>
      <Outlet />
    </div>
  );
};
